import { actionDraw } from "../deck/actionDraw.js";
import { createCardInstance } from "../deck/createInstance.js";
import type { CardInstanceId, RunState } from "../types/index.js";

function selectedIdle(run: RunState, id: CardInstanceId | undefined, allowTemporary: boolean) {
  return run.hand.find((card) => card.instanceId === id && card.cardId === "idle" && (allowTemporary || !card.temporaryForCase));
}

function toggleIdle(run: RunState, kind: "psychologicalCounseling" | "specialTaskTeam", id: CardInstanceId, allowTemporary: boolean): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== kind || !selectedIdle(run, id, allowTemporary)) return null;
  const selected = pending.selected[0] === id ? [] : [id];
  return { ...run, pendingChoice: { ...pending, selected } };
}

export function togglePsychologicalCounseling(run: RunState, id: CardInstanceId): RunState | null {
  return toggleIdle(run, "psychologicalCounseling", id, false);
}

export function toggleSpecialTaskTeam(run: RunState, id: CardInstanceId): RunState | null {
  return toggleIdle(run, "specialTaskTeam", id, true);
}

export function resolvePsychologicalCounseling(run: RunState): RunState {
  const pending = run.pendingChoice;
  const chosen = pending?.kind === "psychologicalCounseling" ? selectedIdle(run, pending.selected[0], false) : undefined;
  if (!chosen) return { ...run, pendingChoice: null };
  const senior = createCardInstance({ nextCardSequence: run.nextCardSequence }, "senior");
  return {
    ...run,
    hand: run.hand.filter((card) => card.instanceId !== chosen.instanceId),
    discard: [...run.discard, senior.instance],
    nextCardSequence: senior.nextCardSequence,
    pendingChoice: null,
  };
}

export function resolveSpecialTaskTeam(run: RunState): { run: RunState; reshuffled: boolean } {
  const pending = run.pendingChoice;
  const chosen = pending?.kind === "specialTaskTeam" ? selectedIdle(run, pending.selected[0], true) : undefined;
  if (!chosen) return { run: { ...run, pendingChoice: null }, reshuffled: false };
  const drawn = actionDraw({ ...run, discard: [...run.discard, chosen] }, 2);
  return {
    reshuffled: drawn.reshuffled,
    run: {
      ...drawn.run,
      hand: [...run.hand.filter((card) => card.instanceId !== chosen.instanceId), ...drawn.drawn],
      deck: drawn.deck,
      discard: drawn.discard,
      rngState: drawn.rngState,
      energy: run.energy + 2,
      activeCase: run.activeCase
        ? { ...run.activeCase, pendingProgress: (run.activeCase.pendingProgress ?? 0) + 2 }
        : run.activeCase,
      pendingChoice: null,
    },
  };
}
